import { matchPath } from "react-router-dom";
import moment from "util/momentWrapper";
import {
  getLocalStorage,
  getSessionStorage,
  setSessionStorage,
} from "../../util/storageUtil";
import callAPI from "../callAPI";
import config from "../config";
import { getCookieCustom, setCookieCustom } from "./cookieUtil";
import { getAppConfig } from "./appConfigHelper";
import { getOATState } from "./oatBridge";

export const getUserInfo = async (type) => {
  try {
    let apiURL = config.api.user.info;
    let apiResponse;

    apiResponse = await callAPI.get(apiURL);

    let regResponse = await apiResponse.json();

    if (regResponse.status === 200) {
      //set-jwtToken-cookie and user-data-localStorage

      localStorage.setItem("userData", JSON.stringify(regResponse));
      if (regResponse.metadata?.status?.r360?.token) {
        setCookieCustom("jwtToken", regResponse.metadata.status.r360.token);
      }

      if (type === "metadata") {
        return regResponse.metadata;
      } else if (type === "both") {
        return regResponse;
      } else {
        return regResponse.data;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const decode = (item) => {
  let newItem = window.atob(item);
  return newItem;
};

export const encode = (item) => {
  let newItem = window.btoa(item);
  return newItem;
};

export const SCREEN_WIDTH = window.innerWidth;
export const SCREEN_HEIGHT = window.innerHeight;

export const isMobileDevice = () => {
  return SCREEN_WIDTH <= 768;
};

export const isTabletDevice = () => {
  return SCREEN_WIDTH > 768 && SCREEN_WIDTH < 1024;
};

export const isDesktopDevice = () => {
  return SCREEN_WIDTH >= 1024;
};

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileP: "390px",
  mobileX: "414px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopM: "1280px",
  laptopL: "1440px",
  laptopX: "1520px",
  desktop: "2560px",
};

export const convertSize = (reqSize) => {
  return parseInt(size[reqSize].slice(0, -2));
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileP: `(min-width: ${size.mobileP})`,
  mobileX: `(min-width: ${size.mobileX})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopX: `(min-width: ${size.laptopX})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

export const sortByProperty = (ar, property) => {
  return ar.sort((a, b) => (a[property] > b[property] ? 1 : -1));
};

export const handleApiCaching = (key, data) => {
  if (data) {
    setSessionStorage(key, data);
  } else {
    let existingData = getSessionStorage(key);
    if (existingData) {
      return existingData;
    } else {
      return false;
    }
  }
};

export const destroyCookie = (name) => {
  const paths = ['/', window.location.pathname];
  const hostParts = window.location.hostname.split('.');

  const domains = [''];

  while (hostParts.length > 0) {
    const domainStr = hostParts.join('.');
    domains.push(domainStr);
    domains.push(`.${domainStr}`);
    hostParts.shift();
  }

  paths.forEach((path) => {
    domains.forEach((domain) => {
      const domainAttr = domain ? `; domain=${domain}` : '';
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}${domainAttr}`;
    });
  });
};

export const deleteAllCookies = () => {
  let cookies = document.cookie.split(";");

  if (cookies) {
    for (const element of cookies) {
      let cookie = element;
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
};

export const capitalize = (word) => {
  if (word) {
    const loweredCase = word.toLowerCase();
    return word[0].toUpperCase() + loweredCase.slice(1);
  }
};

export const isLoggedIn = () => {
  let gwLoginData = getCookieCustom("gwLoginData");
  if (gwLoginData) {
    gwLoginData = JSON.parse(gwLoginData);
  }

  return !!(gwLoginData && gwLoginData?.userId);
};

export const getLoggedInUserId = () => {
  if (!isLoggedIn()) {
    return null;
  }
  let gwLoginData = getCookieCustom("gwLoginData");
  if (gwLoginData) {
    gwLoginData = JSON.parse(gwLoginData);
  }

  return gwLoginData?.userId;
};

export const toHoursAndMinutesFromMinutes = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { hours, minutes };
};

export const toHoursAndMinutesAndSecondsFromSeconds = (totalSeconds) => {
  //With seconds, minute rounded down
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = totalSeconds % 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { h: hours, m: minutes, s: seconds };
};

export const toHoursAndMinutesFromSeconds = (totalSeconds) => {
  //With seconds, minute rounded down
  const totalMinutes = Math.ceil(totalSeconds / 60);

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { h: hours, m: minutes };
};

export const toMinutesFromSeconds = (totalSeconds) => {
  //Rounded off to the higher minute
  return Math.ceil(totalSeconds / 60);
};

//**Flight Information & Flight Card */
export const getGateInfo = (gates) => {
  let str = "";
  gates.forEach((gate, index) => {
    str = str + gate.gateNumber + `${index !== gates.length - 1 ? ", " : ""}`;
  });
  return str;
};

export const getBaggageInfo = (belts) => {
  let str = "";
  belts.forEach((belt, index) => {
    str = str + belt.beltNumber + `${index !== belts.length - 1 ? ", " : ""}`;
  });
  return str;
};

export const formatRupees = (number) => {
  if (number) {
    // Convert the number to a string
    const strNumber = number.toString();
    // Split the number into integer and decimal parts (if any)
    const parts = strNumber.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] ? "." + parts[1] : "";

    // Add commas to the integer part
    const regex = /(\d)(?=(\d{3})+(?!\d))/g;
    integerPart = integerPart.replace(regex, "$1,");

    // Return the formatted rupees
    return integerPart + decimalPart;
  } else {
    return 0;
  }
};

export const getFlightInfo = async (flightData, dateFormat) => {
  if (flightData) {
    let id = flightData?.flightId;
    let flightDate = flightData?.scheduleDate;
    let flightMovementType = flightData?.movementType;

    let date = moment(flightDate, "UTC", "UTC").format();

    let movementType = "Departure";
    if (flightMovementType === "A") movementType = "Arrival";

    try {
      let apiURL = config.api.flightSearch
        .replace("{{date}}", date)
        .replace("{{movementType}}", movementType)
        .replace("{{flightNo}}", id);
      let apiResponse = await callAPI.get(apiURL);
      let regResponse = await apiResponse.json();
      if (regResponse.data.length > 0) {
        if (regResponse.data[0]?.terminal) {
          return regResponse.data[0];
        } else {
          throw Error();
        }
      } else {
        throw Error();
      }
    } catch (e) {
      return false;
    }
  }
};

export const getArtAndCultureInfo = async () => {
  try {
    let apiURL = config.api.pages.replace(
      "{{pageId}}",
      "pulse-art-and-culture",
    );
    let apiResponse = await callAPI.get(apiURL);
    let regResponse = await apiResponse.json();
    if (apiResponse.status === 200) {
      return regResponse;
    }
  } catch (e) {
    console.log(e);
  }
};

export const splitCamelCaseString = (input) => {
  let regex = /([a-z])([A-Z])/g;
  let result = input.replace(regex, "$1 $2");
  const words = result
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return words.join(" ");
};

export const goTop = () => {
  let timerId = setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    clearTimeout(timerId);
  }, 100);
};

export const removeAppliedCoupon = () => {
  let promoData = JSON.parse(
    JSON.stringify(getSessionStorage("availablePromo")),
  );
  promoData?.data?.forEach((x) => {
    if (x.couponCode) {
      delete x.couponCode;
    }
  });
  setSessionStorage("availablePromo", promoData);
};

export const removeSpace = (str) => {
  return str.replace(" ", "");
};

export const formatPrice = (amount) => {
  const configData = getLocalStorage("config") || {};
  const countryCode = configData?.countryCode || "US";

  const optionsByCountry = {
    US: {
      locale: "en-US",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      truncate: true,
    },
    DK: {
      locale: "da-DK",
      currency: "DKK",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      truncate: false,
    },
    GB: {
      locale: "en-GB",
      currency: "GBP",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      truncate: true,
    },
    // Add more countries as needed
  };

  const options = optionsByCountry[countryCode];
  let displayAmount = amount;
  if (options.truncate) {
    displayAmount = truncateTo2DecimalsStr(displayAmount);
  }

  const formatter = new Intl.NumberFormat(options.locale, {
    style: "currency",
    currency: options.currency,
    minimumFractionDigits: options.minimumFractionDigits,
    maximumFractionDigits: options.maximumFractionDigits,
  });

  let formatted = formatter.format(displayAmount);

  // Remove period from 'kr.' if country is Denmark
  if (countryCode === "DK") {
    formatted = formatted.replace("kr.", "kr");
  }

  return `${formatted}`;
};

export const truncateTo2DecimalsStr = (num) => {
  if (isNaN(num) || num === null || num === undefined) {
    return "";
  }
  const [intPart, decimalPart = ""] = num?.toString()?.split(".");
  const truncatedDecimal = decimalPart?.slice(0, 2)?.padEnd(2, "0");
  return `${intPart}.${truncatedDecimal}`;
};

export const isValidPrice = (val) => {
  if (val !== null && val !== undefined && val !== 0) {
    return true;
  } else {
    return false;
  }
};

export function sortByKey(array, key) {
  return [...array].sort((a, b) => {
    if (a[key] < b[key]) return -1;
    if (a[key] > b[key]) return 1;
    return 0;
  });
}

export const toLowerCaseObject = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key.toLowerCase()] =
      typeof obj[key] === "string" ? obj[key].toLowerCase() : obj[key];
    return acc;
  }, {});
};

export function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((sortedObj, key) => {
      sortedObj[key] = obj[key];
      return sortedObj;
    }, {});
}

export const fetchQueryURL = (url, urlParts, keyParts) => {
  const frontIndex = url.indexOf(keyParts);
  if (frontIndex === -1) return {};

  const path = url.substring(frontIndex + keyParts.length);
  const [pathPart, queryPart] = path.split("?");
  const decodedPath = decodeURIComponent(pathPart || "");

  if (!pathPart && !queryPart) return;

  const queryObject = {
    supportedFulfillmentTypes: "collect at store",
    domain: "",
    terminal: null,
  };

  if (urlParts.length > 0 && decodedPath) {
    const parts = decodedPath
      .split("__")
      .map((part) => part.replace(/_/g, "-").replace(/\|/g, "/"));

    urlParts.forEach((key, index) => {
      queryObject[key] = parts[index] || null;
    });

    if (parts.length > 1) {
      queryObject.terminal = parts[1];
    }
  }

  if (queryPart) {
    const params = new URLSearchParams(queryPart);
    for (const [key, value] of params.entries()) {
      queryObject[key] = value;
    }
  }
  return queryObject;
};

export const hasAllValues = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (key === "domain" || key === "sector" || key === "section") {
        if (value === null || value === undefined || value === "") {
          return false;
        }
        continue;
      }

      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        if (!hasAllValues(value)) {
          return false;
        }
      } else if (Array.isArray(value)) {
        if (value.length === 0) {
          return true;
        }
      } else if (value === undefined || value === null || value === "") {
        return true;
      }
    }
  }
  return false;
};

export const buildStorefrontPath = (storeObj) => {
  const encodedStoreName = slugify(storeObj?.storeDisplayName || "");
  const encodedTerminalValue = encodeURIComponent(storeObj?.terminal?.value || "");
  const basePath = `${encodedStoreName}__${encodedTerminalValue}`;
  return storeObj?.waypointId
    ? `${basePath}__${encodeURIComponent(storeObj.waypointId)}`
    : basePath;
};

export const isLargeDesktopDevice = () => {
  return SCREEN_WIDTH >= 1440;
};

export const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^\w_]+/g, "")
    .replace(/__+/g, "_");

export const isLaxDomain = () => {
  if (window?.location?.href?.toLowerCase()?.includes("lax")) {
    return true;
  } else {
    return false;
  }
};

export function getQueryParamValues(paramName, url = window.location.href) {
  if (!paramName) return null;

  try {
    const parsedUrl = new URL(url);

    // Get all occurrences of the param
    const allParams = parsedUrl.searchParams.getAll(paramName);

    if (!allParams.length) return null;

    // Split by comma, trim whitespace, remove empty values
    const values = allParams
      .flatMap((param) => param.split(","))
      .map((value) => value.trim())
      .filter(Boolean);

    return values.length ? values : null;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}

export const addPromoCode = async (promoCode) => {
  let applicablePromo = getSessionStorage("availablePromo");

  // Safely get the first stored coupon code
  const storedCoupon = applicablePromo?.data?.[0]?.couponCode?.[0] || "";

  // Determine if applicablePromo has a valid structure
  const hasValidApplicablePromo =
    Array.isArray(applicablePromo?.data) &&
    applicablePromo.data[0] &&
    Array.isArray(applicablePromo.data[0]?.couponCode) &&
    applicablePromo.data[0]?.couponCode.length > 0;

  const promoAlreadyPresent =
    storedCoupon?.toLowerCase() === promoCode?.toLowerCase();

  // Only override if either:
  // 1️⃣ applicablePromo is missing/invalid
  // 2️⃣ stored promo is different from the new promoCode
  if (!hasValidApplicablePromo || !promoAlreadyPresent) {
    applicablePromo = {
      data: [{ couponCode: [promoCode] }],
    };
    // setSessionStorage("availablePromo", applicablePromo);
  }
};

export const extractYouTubeId = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.searchParams.get("v") || urlObj.pathname.replace("/", "");
  } catch {
    return "";
  }
};

export const getSeparator = (locationId) => {
  const { defaultSeparator, customSeparator } = config?.separators;
  return customSeparator[locationId] ?? defaultSeparator;
};

export const getLocationString = (
  terminalLabel,
  pickupLocation,
  locationId,
) => {
  const seperator = getSeparator(locationId);

  return `${terminalLabel ? terminalLabel.trim() : ""}${terminalLabel && pickupLocation
    ? `${seperator} ${pickupLocation.trim()}`
    : pickupLocation
      ? pickupLocation.trim()
      : ""
    }`;
};

export const getCookieDomain = () => {
  const { isOAT = false } = getOATState();
  const isLocalhost = window.location.hostname === "localhost";
  if (isLocalhost) {
    return "localhost";
  }

  const domain = isOAT
    ? getAppConfig("COOKIE_OAT_DOMAIN") || getAppConfig("COOKIE_DOMAIN")
    : getAppConfig("COOKIE_DOMAIN");

  return domain || getAppConfig("LOGIN_COOKIE_DOMAIN") || "";
};

export const getCookieConfig = () => {
  const domain = getCookieDomain();
  const expiryDays = getAppConfig("LOGIN_COOKIE_EXPIRY_DAYS");
  return { domain, expiryDays };
};

export const setDomianCookieObj = () => {
  try {
    const { domain, expiryDays } = getCookieConfig();
    const options = {
      path: "/",
    };
    const days = Number(expiryDays);
    if (!isNaN(days) && days > 0) {
      options.maxAge = 86400 * days;
    }

    if (domain) {
      options.domain = domain;
    }

    return options;
  } catch (err) {
    console.error("setDomianCookieObj error:", err);
    return { path: "/" };
  }
};

export const removeDomainCookieObj = () => {
  try {
    const { domain } = getCookieConfig();
    const options = {
      path: "/",
    };
    if (domain) {
      options.domain = domain;
    }
    return options;
  } catch (err) {
    console.error("removeDomainCookieObj error:", err);
    return { path: "/" };
  }
};

export const isV4Template = () => {
  return getAppConfig("TEMPLATE_ID") === "TemplateFour";
};

export const isCartPage = (pathname) => {
  return !!matchPath(pathname, {
    path: ["/cart", "/:languageCode/cart"],
    exact: true,
  });
};

const setStorageAccessStatus = (sessionKey, value) => {
  try {
    if (sessionKey) sessionStorage.setItem(sessionKey, value);
  } catch (err) {
    // Ignore best-effort diagnostics.
  }
};

const logStorageAccess = (status, details) => {
  console.info("[StorageAccess]", status, {
    userActivation: navigator.userActivation?.isActive ?? "unknown",
    ...details,
  });
};

const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (err) {
    return true;
  }
};

export const ensureStorageAccess = async (sessionKey) => {
  const inIframe = isInIframe();
  const isSupported = Boolean(document.requestStorageAccess);

  logStorageAccess("check", { sessionKey, inIframe, isSupported });

  if (!inIframe) {
    logStorageAccess("skipped:not_iframe", { sessionKey });
    return true;
  }

  if (!isSupported) {
    setStorageAccessStatus(sessionKey, "unsupported");
    logStorageAccess("skipped:unsupported", { sessionKey });
    return true;
  }

  try {
    setStorageAccessStatus(sessionKey, "pending");
    logStorageAccess("request:start", { sessionKey });
    await document.requestStorageAccess();
    setStorageAccessStatus(sessionKey, "granted");
    logStorageAccess("request:granted", { sessionKey });
    return true;
  } catch (err) {
    setStorageAccessStatus(sessionKey, "denied");
    logStorageAccess("request:denied", {
      sessionKey,
      error: err?.message || err,
    });
    return false;
  }
};

export function isNumber(value) {
  return value !== "" && !isNaN(Number(value));
}


// Merges split timing entries for a given day.
const mergeDayTimings = (dayTimings) => {
  if (!dayTimings || dayTimings.length === 0) return null;

  // Sort by start time
  const sorted = [...dayTimings].sort((a, b) => {
    const aStart = parseInt(a.startHour) * 60 + parseInt(a.startMin);
    const bStart = parseInt(b.startHour) * 60 + parseInt(b.startMin);
    return aStart - bStart;
  });

  // Check for all-day (00:00 - 23:59)
  if (sorted.length === 1) {
    const s = sorted[0];
    if (s.startHour === "00" && s.startMin === "00" && s.endHour === "23" && s.endMin === "59") {
      return { entries: sorted, mergedStart: "00:00", mergedEnd: "23:59", isAllDay: true, isConsecutiveSplit: false };
    }
  }

  // Check for consecutive split: one ends at 23:59, another starts at 00:00
  const endsAtMidnight = sorted.find(t => t.endHour === "23" && t.endMin === "59");
  const startsAtMidnight = sorted.find(t => t.startHour === "00" && t.startMin === "00");

  if (sorted.length >= 2 && endsAtMidnight && startsAtMidnight && endsAtMidnight !== startsAtMidnight) {
    // Consecutive split — merge into one range from endsAtMidnight.start to startsAtMidnight.end
    return {
      entries: sorted,
      mergedStart: `${endsAtMidnight.startHour}:${endsAtMidnight.startMin}`,
      mergedEnd: `${startsAtMidnight.endHour}:${startsAtMidnight.endMin}`,
      isAllDay: false,
      isConsecutiveSplit: true,
    };
  }

  // Non-consecutive — return first entry as primary
  return {
    entries: sorted,
    mergedStart: `${sorted[0].startHour}:${sorted[0].startMin}`,
    mergedEnd: `${sorted[0].endHour}:${sorted[0].endMin}`,
    isAllDay: false,
    isConsecutiveSplit: false,
  };
};

export const getStoreTimeForCurrentDay = (shopTimings) => {
    const currMoment = moment();
    const currDay = currMoment.format("ddd");
    const currTime = currMoment.hours() * 60 + currMoment.minutes();

    if (shopTimings?.length > 0) {
      // Get all timing entries for the current day
      const dayTimings = shopTimings?.filter((x) => x?.dayOfWeek?.includes(currDay));
      if (dayTimings?.length > 0) {
        // Check if current time falls within any of the entries
        const isOpen = dayTimings.some((t) => {
          const start = parseInt(t.startHour) * 60 + parseInt(t.startMin);
          const end = parseInt(t.endHour) * 60 + parseInt(t.endMin);
          return currTime >= start && currTime <= end;
        });

        const merged = mergeDayTimings(dayTimings);

        if (isOpen) {
          if (merged?.isAllDay) {
            return "Open all day";
          }
          // For consecutive splits, show the final merged closing time
          const end12hr = convertTimeFormat(merged.mergedEnd);
          return `Open until ${end12hr}`;
        } else {
          // Find the next upcoming start time
          const upcoming = dayTimings
            .map((t) => ({
              startMin: parseInt(t.startHour) * 60 + parseInt(t.startMin),
              startStr: `${t.startHour}:${t.startMin}`,
            }))
            .filter((t) => t.startMin > currTime)
            .sort((a, b) => a.startMin - b.startMin);

          if (upcoming.length > 0) {
            const start12hr = convertTimeFormat(upcoming[0].startStr);
            return `Closed - Opens at ${start12hr}`;
          }
          // If no upcoming time today, show earliest start
          const start12hr = convertTimeFormat(merged.mergedStart);
          return `Closed - Opens at ${start12hr}`;
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

/**
 * Shared isOrderNowEnabled — checks if the store is currently open
 * by looking at all timing entries for the current day.
 * Supports split timings (multiple entries for the same dayOfWeek).
 * @param {Array} shopTimings - Array of timing objects from the API
 * @param {Object} [options] - Optional: { isScheduled, deliveryTime } for scheduled orders
 * @returns {boolean}
 */
export const isOrderNowEnabled = (shopTimings, options = {}) => {
  const currMoment = options?.isScheduled ? moment(options.deliveryTime) : moment();
  const currDay = currMoment.format("ddd");
  const currTime = currMoment.hours() * 60 + currMoment.minutes();

  if (shopTimings?.length > 0) {
    const dayTimings = shopTimings.filter((x) => x?.dayOfWeek?.includes(currDay));
    return dayTimings.some((t) => {
      const shopStartTime = parseInt(t.startHour) * 60 + parseInt(t.startMin);
      const shopEndTime = parseInt(t.endHour) * 60 + parseInt(t.endMin);
      return currTime >= shopStartTime && currTime <= shopEndTime;
    });
  }
  return false;
};

export const fetchTiming = (data) => {
    // Collect all timing ranges per day (supports multiple entries per day)
    let timingSet = {};
    data?.forEach((item) => {
      item?.dayOfWeek?.forEach((day) => {
        if (!timingSet[day]) {
          timingSet[day] = [];
        }
        timingSet[day].push({
          start: `${item.startHour}:${item.startMin}`,
          end: `${item.endHour}:${item.endMin}`,
          startHour: item.startHour,
          startMin: item.startMin,
          endHour: item.endHour,
          endMin: item.endMin,
        });
      });
    });

    // Merge consecutive splits per day
    const mergedTimingSet = {};
    Object.keys(timingSet).forEach((day) => {
      const entries = timingSet[day];
      if (entries.length === 1) {
        mergedTimingSet[day] = {
          start: entries[0].start,
          end: entries[0].end,
          hasOverflow: false,
        };
      } else {
        // Check for consecutive split (23:59 -> 00:00)
        const endsAtMidnight = entries.find(t => t.end === "23:59");
        const startsAtMidnight = entries.find(t => t.start === "00:00");

        if (endsAtMidnight && startsAtMidnight && endsAtMidnight !== startsAtMidnight) {
          mergedTimingSet[day] = {
            start: endsAtMidnight.start,
            end: startsAtMidnight.end,
            hasOverflow: true,
          };
        } else {
          // Non-consecutive: use earliest start, latest end
          const sorted = [...entries].sort((a, b) => {
            const aStart = parseInt(a.startHour) * 60 + parseInt(a.startMin);
            const bStart = parseInt(b.startHour) * 60 + parseInt(b.startMin);
            return aStart - bStart;
          });
          mergedTimingSet[day] = {
            start: sorted[0].start,
            end: sorted[sorted.length - 1].end,
            hasOverflow: false,
          };
        }
      }
    });

    // Check for overflow: if end time < start time in minutes, it overflows to next day
    Object.keys(mergedTimingSet).forEach((day) => {
      const entry = mergedTimingSet[day];
      const [sH, sM] = entry.start.split(":").map(Number);
      const [eH, eM] = entry.end.split(":").map(Number);
      if ((eH * 60 + eM) < (sH * 60 + sM)) {
        entry.hasOverflow = true;
      }
    });

    const message = formatTimings(mergedTimingSet);
    return message || [];
  };

export const formatTimings = (timingSet) => {
    let formatted = [];
    let currentStart = null;
    let currentEnd = null;
    let currentTime = null;
    let currentDays = [];

    const dayOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const daysOfWeek = Object.keys(timingSet).sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

    daysOfWeek.forEach((day, index) => {
      const timing = timingSet[day];

      if (currentStart === null) {
        currentStart = day;
        currentEnd = day;
        currentTime = timing;
        currentDays = [day];
      }

      if (index > 0) {
        const prevTiming = timingSet[daysOfWeek[index - 1]];

        if (
          timing.start === prevTiming.start &&
          timing.end === prevTiming.end &&
          timing.hasOverflow === prevTiming.hasOverflow
        ) {
          currentEnd = day;
          currentDays.push(day);
        } else {
          const dayLabel = currentEnd !== currentStart
            ? `${currentStart} – ${currentEnd}`
            : getDayFullName(currentStart);
          formatted.push({
            range: dayLabel,
            time: formatTimeRange(currentTime),
            hasOverflow: currentTime.hasOverflow || false,
            days: currentDays,
          });

          currentStart = day;
          currentEnd = day;
          currentTime = timing;
          currentDays = [day];
        }
      }
      if (index === daysOfWeek.length - 1) {
        const dayLabel = currentEnd !== currentStart
          ? `${currentStart} – ${currentEnd}`
          : getDayFullName(currentStart);
        formatted.push({
          range: dayLabel,
          time: formatTimeRange(timing),
          hasOverflow: timing.hasOverflow || false,
          days: currentDays,
        });
      }
    });

    return formatted;
  };

const getDayFullName = (abbr) => {
  const map = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };
  return map[abbr] || abbr;
};

export const formatTimeRange = (time) => {
  if (time.start === "00:00" && time.end === "23:59") {
    return "Open all day";
  }

    const start12hr = convertTimeFormat(time.start);
    const end12hr = convertTimeFormat(time.end);
    return `${start12hr} - ${end12hr}`;
  };

export const convertTimeFormat = (time) => {
    const [hour, minute] = time.split(":");
    let hour12 = parseInt(hour, 10);
    const period = hour12 >= 12 ? "PM" : "AM";
    if (hour12 > 12) hour12 -= 12;
    if (hour12 === 0) hour12 = 12;
    return `${hour12}:${minute} ${period}`;
  };

export const getCurrentDayTimingRow = (timingArray) => {
  if (!timingArray || timingArray.length === 0) return null;
  const currDay = moment().format("ddd"); // 'Mon', 'Tue', etc.
  
  // Find the row that includes the current day
  const row = timingArray.find((item) => item.days && item.days.includes(currDay));
  
  // Fallback to the first row if for some reason the current day isn't found
  return row || timingArray[0];
};
  
export const convertDataOrderSummary = (response) => {
  let data = [];
  let metadata = {};
  let responseData = [];
  let finalData = {};

  metadata = response.metadata;
  responseData = response?.data;

  if (data.length === 0) {
    responseData?.forEach((x) => {
      const storeFound = data?.find(
        (str) => str?.shopDetails?.shopId === x?.shopDetails?.shopId,
      );
      if (!storeFound) {
        data.push({
          shopDetails: x?.shopDetails,
          items: [],
        });
      }
    });
  }

  data?.forEach((localData) => {
    responseData?.forEach((respData) => {
      if (localData?.shopDetails?.shopId === respData?.shopDetails?.shopId) {
        localData.items = localData?.items?.concat(respData);
      }
    });
  });

  finalData.data = data;
  finalData.metadata = metadata;

  return finalData;
};

export const parseCaptchaQuestion = (question) => {
  const clean = question.replace(/[^0-9+\-]/g, "").trim();

  let correctAnswer = 0;

  if (clean.includes("+")) {
    const [a, b] = clean.split("+").map(Number);
    correctAnswer = a + b;
  } else if (clean.includes("-")) {
    const [a, b] = clean.split("-").map(Number);
    correctAnswer = a - b;
  }

  const wrong1 = correctAnswer + Math.floor(Math.random() * 5 + 1);
  const wrong2 = correctAnswer - Math.floor(Math.random() * 5 + 1);

  const options = [correctAnswer, wrong1, wrong2].sort(
    () => Math.random() - 0.5
  );

  return { correctAnswer, options };
};

export const showCaptchaPrompt = async (question) => {
  return new Promise((resolve) => {
    const answer = window.prompt(`Security check:\n\n${question}`);
    resolve(answer);
  });
};

export const buildSelectedStructure = (selectedPreference, fullPreference) => {
  const preferenceObj = {};

  // Flatten the tree and save parent information for each preference
  const traverseTree = (items, parentSku, parentGroupType) => {
    items.forEach((item) => {
      preferenceObj[item.preferenceSku] = {
        item,
        parentSku,
        parentGroupType,
      };

      if (item.subPreferences?.length > 0) {
        item.subPreferences.forEach((group) => {
          traverseTree(group.preferenceValues ?? [], item.preferenceSku, group.type);
        });
      }
    });
  };

  fullPreference.forEach((rootGroup) => {
    traverseTree(rootGroup.preferenceValues ?? [], null, rootGroup.type);
  });

  //selected child sku and get the full parent path
  const getParentPath = (leafSku, leafQty) => {
    const chain = [];
    let current = preferenceObj[leafSku];
    let isLeaf = true;

    while (current) {
      chain.unshift({
        sku: current.item.preferenceSku,
        name: current.item.name,
        price: current.item.price,
        groupType: current.parentGroupType,
        parentSku: current.parentSku,
        quantity: isLeaf ? (leafQty ?? 1) : 1,
      });
      isLeaf = false;
      current = current.parentSku ? preferenceObj[current.parentSku] : null;
    }

    return chain;
  };

  // Merge all selected paths and rebuild the selection structure
  const selectedPre = (chains) => {
    if (chains.length === 0) return [];

    const currentPre = {};

    chains.forEach((chain) => {
      if (chain.length === 0) return;
      const topSku = chain[0].sku;
      if (!currentPre[topSku]) currentPre[topSku] = [];
      currentPre[topSku].push(chain);
    });

    return Object.entries(currentPre).map(([topSku, topChains]) => {
      const topNode = topChains[0][0];
      const result = {
        preferenceSku: topNode.sku,
        name: topNode.name,
        price: topNode.price,
        quantity: topNode?.quantity
      };

      const subSelections = groupedSelections(topChains, 1);
      if (subSelections.length > 0) {
        result.subSelections = subSelections;
      }

      return result;
    });
  };

  // Recursively build nested selections from parent-child paths
  const groupedSelections = (chains, depth) => {
    const nestedSelections = chains.filter((chain) => chain.length > depth);
    if (nestedSelections.length === 0) return [];

    const selectedPre = {};
    nestedSelections.forEach((chain) => {
      const node = chain[depth];
      const groupType = node.groupType || "unknown";
      if (!selectedPre[groupType]) selectedPre[groupType] = [];
      selectedPre[groupType].push(chain);
    });

    return Object.entries(selectedPre).map(([groupType, groupChains]) => {
      const selectedValues = {};
      groupChains.forEach((chain) => {
        const sku = chain[depth].sku;
        if (!selectedValues[sku]) selectedValues[sku] = [];
        selectedValues[sku].push(chain);
      });

      const selection = Object.entries(selectedValues).map(([sku, skuChains]) => {
        const node = skuChains[0][depth];
        const item = {
          preferenceSku: node.sku,
          name: node.name,
          price: node.price,
          quantity: node?.quantity
        };

        // Recurse deeper
        const deeper = groupedSelections(skuChains, depth + 1);
        if (deeper.length > 0) {
          item.subSelections = deeper;
        }

        return item;
      });

      return {
        title: groupType,
        selection,
      };
    });
  };

  const result = [];

  Object.entries(selectedPreference).forEach(([key, selectedItems]) => {
    if (!Array.isArray(selectedItems) || selectedItems.length === 0) return;

    const rootGroup = fullPreference.find((g) => g.type === key);
    if (!rootGroup) return;

    const chains = selectedItems
      .map((item) => getParentPath(item.preferenceSku, item.quantity))
      .filter((chain) => chain.length > 0);

    const selection = selectedPre(chains);

    result.push({
      title: key,
      selection,
    });
  });

  return result;
};

export const buildPreferencesStructure = (
  selectedPreference,
  fullPreference
) => {
  const preferenceObj = {};

  const mapNodes = (
    items,
    parentSku = null,
    parentGroupPreferenceId = null
  ) => {
    items.forEach((item) => {
      preferenceObj[item.preferenceSku] = {
        sku: item.preferenceSku,
        parentSku,
        parentGroupPreferenceId,
      };

      item.subPreferences?.forEach((group) => {
        mapNodes(
          group.preferenceValues || [],
          item.preferenceSku,
          group.preferenceId
        );
      });
    });
  };

  fullPreference.forEach((rootGroup) => {
    mapNodes(
      rootGroup.preferenceValues || [],
      null,
      rootGroup.preferenceId
    );
  });

  const getParentPath = (sku) => {
    const chain = [];
    let node = preferenceObj[sku];

    while (node) {
      chain.unshift({
        sku: node.sku,
        groupPreferenceId: node.parentGroupPreferenceId,
      });

      node = node.parentSku
        ? preferenceObj[node.parentSku]
        : null;
    }

    return chain;
  };

  const collectSelectedSkus = (items, result = [], quantityMap = {}) => {
    items.forEach((item) => {
      if (item.preferenceSku) {
        result.push(item.preferenceSku);
        quantityMap[item.preferenceSku] = item.quantity ?? 1;
      }

      item.subSelections?.forEach((sub) => {
        collectSelectedSkus(sub.selection || [], result, quantityMap);
      });
    });

    return { result, quantityMap };
  };

  const buildValues = (chains, depth, quantityMap) => {
    const grouped = {};

    chains.forEach((chain) => {
      if (chain.length <= depth) return;

      const sku = chain[depth].sku;

      if (!grouped[sku]) {
        grouped[sku] = [];
      }

      grouped[sku].push(chain);
    });

    return Object.entries(grouped).map(
      ([sku, groupedChains]) => {
        const value = {
          preferenceValueId: sku,
        };

        const subGroups = {};

        groupedChains.forEach((chain) => {
          if (chain.length <= depth + 1) return;

          const nextGroupId =
            chain[depth + 1].groupPreferenceId;

          if (!nextGroupId) return;

          if (!subGroups[nextGroupId]) {
            subGroups[nextGroupId] = [];
          }

          subGroups[nextGroupId].push(chain);
        });

        const subPreferences = Object.entries(
          subGroups
        ).map(([groupId, chains]) => ({
          preferenceId: groupId,
          values: buildValues(chains, depth + 1, quantityMap),
        }));

        if (subPreferences.length > 0) {
          value.subPreferences = subPreferences;
        }

        value.quantity = quantityMap[sku] ?? 1;

        return value;
      }
    );
  };

  return Object.entries(selectedPreference)
    .filter(
      ([, items]) =>
        Array.isArray(items) && items.length > 0
    )
    .map(([groupType, items]) => {
      const rootGroup = fullPreference.find(
        (g) => g.type === groupType
      );

      if (!rootGroup) return null;

      const { result: selectedSkus, quantityMap } =
        collectSelectedSkus(items);

      const chains = selectedSkus
        .map((sku) => getParentPath(sku))
        .filter((chain) => chain.length > 0);

      return {
        preferenceId: rootGroup.preferenceId,
        quantity: 1,
        values: buildValues(chains, 0, quantityMap),
      };
    })
    .filter(Boolean);
};

export const flattenSelections = (items = []) => {
  const flattened = [];

  const traverse = (node) => {
    if (!node) return;

    flattened.push(node);

    (node.subSelections || []).forEach((group) => {
      (group.selection || []).forEach((child) => {
        traverse(child);
      });
    });
  };

  items.forEach(traverse);

  return flattened;
};


export const flattenNestedSelection = (selections, parentSku = null, preferenceId = null) => {
  let flat = [];
  selections.forEach((sel) => {
    flat.push({
      preferenceSku: sel.preferenceSku,
      name: sel.name,
      price: sel.price,
      parentPreferenceSku: parentSku,
      isSubPreferenceSelected: parentSku !== null,
      preferenceId: preferenceId || sel.preferenceId,
    });
    if (sel.subSelections && Array.isArray(sel.subSelections)) {
      sel.subSelections.forEach((subGroup) => {
        flat = flat.concat(flattenNestedSelection(subGroup.selection || [], sel.preferenceSku, preferenceId || sel.preferenceId));
      });
    }
  });
  return flat;
};


export const customisationReStrPreferences = (selectedPreference) => {
  if (!selectedPreference || typeof selectedPreference !== "object") {
    return [];
  }

  const cleanSelection = (items = []) =>
    items.map((item) => {
      const cleaned = {
        preferenceSku: item.preferenceSku,
        name: item.name,
        price: item.price,
        quantity: item.quantity ?? 1
      };

      if (
        Array.isArray(item.subSelections) &&
        item.subSelections.length > 0
      ) {
        cleaned.subSelections = item.subSelections
          .map((sub) => ({
            title: sub.title,
            selection: cleanSelection(sub.selection || []),
          }))
          .filter((sub) => sub.selection.length > 0);

        if (cleaned.subSelections.length === 0) {
          delete cleaned.subSelections;
        }
      }

      return cleaned;
    });

  return Object.entries(selectedPreference).map(
    ([title, selection]) => ({
      title,
      selection: cleanSelection(
        Array.isArray(selection) ? selection : []
      ),
    })
  );
};


export const mapPreferenceSelection = (item) => {
  const result = {
    preferenceSku: item.preferenceSku,
    name: item.name,
    price: item.price || 0,
  };

  if (item.subPreferences?.length) {
    result.subSelections = item.subPreferences.map((subPref) => ({
      title: subPref.type,
      selection: (subPref.preferenceValues || []).map((child) =>
        mapPreferenceSelection(child)
      ),
    }));
  }

  return result;
};

const convertSubPreferencesToSubSelections = (items = []) => {
  return items.map((item) => {
    const result = {
      name: item.name,
      preferenceSku: item.preferenceSku,
      price: item.price || 0,
    };

    if (item.subPreferences?.length) {
      result.subSelections = item.subPreferences.map((subPref) => ({
        title: subPref.type,
        selection: convertSubPreferencesToSubSelections(
          subPref.preferenceValues || []
        ),
      }));
    }

    return result;
  });
};

export const buildSelectedPreference = (customisationPreferences) => {
  const result = {};

  customisationPreferences.forEach((rootPref) => {
    const title = rootPref.title;
    const selectedTopItems = [];

    rootPref.selection?.forEach((topItem) => {
      if (topItem.subSelections?.length > 0) {
        const subSelections = extractSelected(topItem.subSelections);

        if (subSelections.length > 0) {
          selectedTopItems.push({
            name: topItem.name,
            preferenceSku: topItem.preferenceSku,
            price: topItem.price,
            subSelections,
            preferenceId: rootPref.preferenceId,
            quantity: topItem?.quantity ?? null,
          });
        }
      } else {
        selectedTopItems.push({
          name: topItem.name,
          preferenceSku: topItem.preferenceSku,
          price: topItem.price,
          preferenceId: rootPref.preferenceId,
          quantity: topItem?.quantity ?? null,
        });
      }
    });

    if (selectedTopItems.length > 0) {
      result[title] = selectedTopItems;
    }
  });

  return result;
};

const flattenWithParentSku = (items = []) => {
  const flattened = [];
  const walk = (item, parentSku) => {
    if (!item) return;
    const { subSelections, subPreferences, ...rest } = item;
    flattened.push({
      ...rest,
      parentPreferenceSku: rest.parentPreferenceSku ?? parentSku ?? null,
    });
    (subSelections || []).forEach((group) => {
      (group?.selection || []).forEach((child) => walk(child, item.preferenceSku));
    });
  };
  items.forEach((item) => walk(item, null));
  return flattened;
};

// Cart selections come back nested (parent -> subSelections) with only
// name/sku/price/quantity. Convert them to the flat, full-option shape the
// add flow builds so max/remove/radio logic behaves the same on update.
export const normalizeLoadedSelection = (loadedSelection = {}, preferences = []) => {
  const optionBySku = {};
  const collectOptions = (options = []) => {
    options.forEach((option) => {
      if (!option?.preferenceSku) return;
      optionBySku[String(option.preferenceSku)] = option;
      (option.subPreferences || []).forEach((group) =>
        collectOptions(group?.preferenceValues || [])
      );
    });
  };
  preferences.forEach((pref) => collectOptions(pref?.preferenceValues || []));

  const result = {};
  Object.entries(loadedSelection).forEach(([type, items]) => {
    const pref = preferences.find((p) => p.type === type);
    const flatList = flattenWithParentSku(items || []);
    const parentSkus = new Set(
      flatList
        .filter((sel) => sel.parentPreferenceSku)
        .map((sel) => String(sel.parentPreferenceSku))
    );

    const normalized = flatList
      .filter((sel) => !parentSkus.has(String(sel.preferenceSku)))
      .map((sel) => {
        const option = optionBySku[String(sel.preferenceSku)] || {};
        const {
          subPreferences,
          preferenceDietCategory,
          isActive,
          ...optionFields
        } = option;
        const normalizedItem = {
          ...sel,
          ...optionFields,
          preferenceId:
            sel.preferenceId ?? pref?._id ?? pref?.preferenceId ?? null,
          isSubPreferenceSelected: true,
          parentPreferenceSku: sel.parentPreferenceSku ?? null,
        };
        if (sel.quantity != null) {
          normalizedItem.quantity = sel.quantity;
        } else {
          delete normalizedItem.quantity;
        }
        return normalizedItem;
      });

    if (normalized.length > 0) {
      result[type] = normalized;
    }
  });

  return result;
};

const extractSelected = (subSelections) => {
  return subSelections
    .map((group) => {
      const selection = (group.selection || []).map((item) => ({
        name: item.name,
        preferenceSku: item.preferenceSku,
        price: item.price,
        quantity: item?.quantity ?? null, 
      }));

      return selection.length > 0
        ? { title: group.title, selection }
        : null;
    })
    .filter(Boolean);
};

export const transformCustomisationPreferences = (input = []) => {
  const cleanSelection = (selection = []) =>
    selection
      .map((item) => {
        const cleaned = {
          name: item.name,
          preferenceSku: item.preferenceSku,
          price: item.price,
          quantity: item?.quantity ?? undefined
        };

        const subs = cleanSubSelections(item.subSelections);

        if (subs.length > 0) {
          cleaned.subSelections = subs;
        }

        return cleaned;
      })
      .filter(Boolean);

  const cleanSubSelections = (subs = []) =>
    Array.isArray(subs)
      ? subs
        .map((s) => {
          const selection = cleanSelection(s.selection);

          if (!selection.length) return null;

          return {
            title: s.title,
            selection,
          };
        })
        .filter(Boolean)
      : [];

  return input.map((group) => ({
    title: group.title,
    selection: cleanSelection(group.selection),
  }));
};


export const updatePreferenceId = (selectedPreference, itemPreferences) => {
  const preferenceIdMap = buildPreferenceIdMap(itemPreferences);

  const updated = {};

  Object.entries(selectedPreference).forEach(([title, items]) => {
    updated[title] = items.map((item) => {
      if (item.preferenceId) return item;

      return {
        ...item,
        preferenceId: preferenceIdMap[item.preferenceSku] ?? null,
      };
    });
  });

  return updated;
};


const buildPreferenceIdMap = (itemPreferences) => {
  const preferenceIdMap = {};

  itemPreferences.forEach((parentPre) => {
    const parentPreferenceId = parentPre.preferenceId;

    const traverse = (items) => {
      items?.forEach((item) => {
        preferenceIdMap[item.preferenceSku] = parentPreferenceId;

        if (item.subPreferences?.length > 0) {
          item.subPreferences.forEach((subPre) => {
            traverse(subPre.preferenceValues ?? []);
          });
        }
      });
    };

    traverse(parentPre.value ?? parentPre.preferenceValues ?? []);
  });

  return preferenceIdMap;
};

export const buildCustomisationPreferences = (selectedPreference, itemPreferences) => {
  const preferenceObj = {};
  const traverseTree = (items, parentSku, parentGroupType) => {
    items.forEach((item) => {
      preferenceObj[item.preferenceSku] = { item, parentSku, parentGroupType };
      if (item.subPreferences?.length > 0) {
        item.subPreferences.forEach((group) =>
          traverseTree(group.preferenceValues ?? [], item.preferenceSku, group.type)
        );
      }
    });
  };
  itemPreferences.forEach((rootGroup) => traverseTree(rootGroup.preferenceValues ?? [], null, rootGroup.type));

  const getParentPath = (leafSku, leafQty) => {
    const chain = [];
    let current = preferenceObj[leafSku];
    let isLeaf = true;
    while (current) {
      chain.unshift({
        sku: current.item.preferenceSku,
        name: current.item.name,
        price: current.item.price,
        groupType: current.parentGroupType,
        parentSku: current.parentSku,
        quantity: isLeaf ? (leafQty ?? 1) : 1,
      });
      isLeaf = false;
      current = current.parentSku ? preferenceObj[current.parentSku] : null;
    }
    return chain;
  };

  const flattenToLeaves = (input) => {
    const leaves = [];
    const collectLeaves = (item) => {
      if (Array.isArray(item.subSelections) && item.subSelections.length > 0) {
        item.subSelections.forEach((group) => (group.selection ?? []).forEach(collectLeaves));
        return;
      }
      leaves.push({ preferenceSku: item.preferenceSku, quantity: item.quantity });
    };

    if (Array.isArray(input)) {
      input.forEach(collectLeaves);
    } else if (input && typeof input === "object") {
      Object.values(input).forEach((items) => {
        if (Array.isArray(items)) items.forEach(collectLeaves);
      });
    }
    return leaves;
  };

  const leaves = flattenToLeaves(selectedPreference);
  const chains = leaves
    .map((leaf) => getParentPath(leaf.preferenceSku, leaf.quantity))
    .filter((chain) => chain.length > 0);

  const groupedSelections = (chainsAtDepth, depth) => {
    const nested = chainsAtDepth.filter((chain) => chain.length > depth);
    if (nested.length === 0) return [];

    const byGroupType = {};
    nested.forEach((chain) => {
      const groupType = chain[depth].groupType || "unknown";
      if (!byGroupType[groupType]) byGroupType[groupType] = [];
      byGroupType[groupType].push(chain);
    });

    return Object.entries(byGroupType).map(([groupType, groupChains]) => {
      const bySku = {};
      groupChains.forEach((chain) => {
        const sku = chain[depth].sku;
        if (!bySku[sku]) bySku[sku] = [];
        bySku[sku].push(chain);
      });

      const selection = Object.entries(bySku).map(([, skuChains]) => {
        const node = skuChains[0][depth];
        const item = { preferenceSku: node.sku, name: node.name, price: node.price, quantity: node.quantity };
        const deeper = groupedSelections(skuChains, depth + 1);
        if (deeper.length > 0) item.subSelections = deeper;
        return item;
      });

      return { title: groupType, selection };
    });
  };

  const byRootSku = {};
  chains.forEach((chain) => {
    const topSku = chain[0].sku;
    if (!byRootSku[topSku]) byRootSku[topSku] = [];
    byRootSku[topSku].push(chain);
  });

  const topLevelItems = Object.entries(byRootSku).map(([, topChains]) => {
    const topNode = topChains[0][0];
    const item = { preferenceSku: topNode.sku, name: topNode.name, price: topNode.price, quantity: topNode.quantity };
    const deeper = groupedSelections(topChains, 1);
    if (deeper.length > 0) item.subSelections = deeper;
    return item;
  });

  const byRootType = {};
  chains.forEach((chain) => {
    const rootType = chain[0].groupType || "unknown";
    if (!byRootType[rootType]) byRootType[rootType] = new Set();
    byRootType[rootType].add(chain[0].sku);
  });

  return Object.entries(byRootType).map(([title, skuSet]) => ({
    title,
    selection: topLevelItems.filter((item) => skuSet.has(item.preferenceSku)),
  }));
};


export const storeFrontURL = () => {
  const storeDetail = JSON.parse(getSessionStorage("OAT_STORE_DETAIL"));

  const storeName = storeDetail?.name || "";
  const terminal = storeDetail?.terminal?.value || "";

  const encodedStoreName = slugify(storeName);
  const encodedTerminalValue = encodeURIComponent(terminal);

  return `/storefront/${encodedStoreName}__${encodedTerminalValue}`;
};

const shownRecommendationItemIds = new Set();

export const hasRecommendationBeenShown = (itemId) =>
  shownRecommendationItemIds.has(itemId);

export const markRecommendationShown = (itemId) => {
  shownRecommendationItemIds.add(itemId);
};

export const resetRecommendationShown = (itemId) => {
  shownRecommendationItemIds.delete(itemId);
};

export const getDiscountDetails = (offers = []) => {
  const discountOffer = offers.find(
    (offer) => offer?.rewardType === "discount"
  );

  if (!discountOffer) return null;

  if (discountOffer.discountFlat != null) {
    return {
      type: "flat",
      value: discountOffer.discountFlat,
    };
  }

  if (discountOffer.discountPercentage != null) {
    return {
      type: "percentage",
      value: discountOffer.discountPercentage,
    };
  }

  return null;
};

export const buildSelectedStructureUpdate = (
  selectedPreference,
  fullPreference,
  { includePreferenceId = false } = {}
) => {
  const recordsBySku = {};

  const traverseTree = (items, parent, groupType, rootType) => {
    items.forEach((item) => {
      const record = { item, parent, parentGroupType: groupType, rootType };
      const key = String(item.preferenceSku);
      if (!recordsBySku[key]) recordsBySku[key] = [];
      recordsBySku[key].push(record);

      item.subPreferences?.forEach((group) => {
        traverseTree(group.preferenceValues ?? [], record, group.type, rootType);
      });
    });
  };

  fullPreference.forEach((rootGroup) => {
    traverseTree(rootGroup.preferenceValues ?? [], null, rootGroup.type, rootGroup.type);
  });

  const flattenSelected = (items, parentSku = null, out = []) => {
    items.forEach((item) => {
      out.push({
        preferenceSku: item.preferenceSku,
        quantity: item.quantity,
        parentPreferenceSku: item.parentPreferenceSku ?? parentSku,
        isSubPreferenceSelected: item.isSubPreferenceSelected ?? parentSku != null,
        preferenceId: item.preferenceId,
      });
      item.subSelections?.forEach((group) => {
        flattenSelected(group.selection ?? [], item.preferenceSku, out);
      });
    });
    return out;
  };

  const dedupeSelected = (entries) => {
    const map = new Map();
    entries.forEach((e) => {
      map.set(`${e.parentPreferenceSku ?? ""}|${e.preferenceSku}`, e);
    });
    return [...map.values()];
  };

  const findRecord = (selectedItem, rootType) => {
    const candidates = (recordsBySku[String(selectedItem.preferenceSku)] ?? []).filter(
      (r) => r.rootType === rootType
    );
    if (candidates.length === 0) return null;

    const parentSku = selectedItem.parentPreferenceSku;
    if (parentSku) {
      const match = candidates.find(
        (r) => r.parent && String(r.parent.item.preferenceSku) === String(parentSku)
      );
      if (match) return match;
    }

    if (selectedItem.isSubPreferenceSelected) {
      const nested = candidates.find((r) => r.parent);
      if (nested) return nested;
    }

    return candidates[0];
  };

  const getParentPath = (selectedItem, rootType, selectedQty) => {
    const chain = [];
    let current = findRecord(selectedItem, rootType);
    let isLeaf = true;

    while (current) {
      const sku = current.item.preferenceSku;
      chain.unshift({
        sku,
        name: current.item.name,
        price: current.item.price,
        groupType: current.parentGroupType,
        parentSku: current.parent?.item.preferenceSku ?? null,
        // leaf uses its own quantity; a parent uses its quantity only if it was also selected
        quantity: isLeaf
          ? (selectedItem.quantity ?? 1)
          : (selectedQty[String(sku)] ?? 1),
      });
      isLeaf = false;
      current = current.parent;
    }

    if (chain.length > 0) chain[0].preferenceId = selectedItem.preferenceId;

    return chain;
  };

  const selectedPre = (chains) => {
    if (chains.length === 0) return [];

    const currentPre = {};

    chains.forEach((chain) => {
      if (chain.length === 0) return;
      const topSku = chain[0].sku;
      if (!currentPre[topSku]) currentPre[topSku] = [];
      currentPre[topSku].push(chain);
    });

    return Object.entries(currentPre).map(([topSku, topChains]) => {
      const topNode = topChains[0][0];
      const result = {
        preferenceSku: topNode.sku,
        name: topNode.name,
        price: topNode.price,
        quantity: topNode?.quantity,
      };

      if (includePreferenceId) {
        const preferenceId = topChains.map((c) => c[0].preferenceId).find(Boolean);
        if (preferenceId !== undefined) result.preferenceId = preferenceId;
      }

      const subSelections = groupedSelections(topChains, 1);
      if (subSelections.length > 0) {
        result.subSelections = subSelections;
      }

      return result;
    });
  };

  const groupedSelections = (chains, depth) => {
    const nestedSelections = chains.filter((chain) => chain.length > depth);
    if (nestedSelections.length === 0) return [];

    const grouped = {};
    nestedSelections.forEach((chain) => {
      const node = chain[depth];
      const groupType = node.groupType || "unknown";
      if (!grouped[groupType]) grouped[groupType] = [];
      grouped[groupType].push(chain);
    });

    return Object.entries(grouped).map(([groupType, groupChains]) => {
      const selectedValues = {};
      groupChains.forEach((chain) => {
        const sku = chain[depth].sku;
        if (!selectedValues[sku]) selectedValues[sku] = [];
        selectedValues[sku].push(chain);
      });

      const selection = Object.entries(selectedValues).map(([sku, skuChains]) => {
        const node = skuChains[0][depth];
        const item = {
          preferenceSku: node.sku,
          name: node.name,
          price: node.price,
          quantity: node?.quantity,
        };

        const deeper = groupedSelections(skuChains, depth + 1);
        if (deeper.length > 0) {
          item.subSelections = deeper;
        }

        return item;
      });

      return {
        title: groupType,
        selection,
      };
    });
  };

  const result = [];

  Object.entries(selectedPreference).forEach(([key, selectedItems]) => {
    if (!Array.isArray(selectedItems) || selectedItems.length === 0) return;

    const rootGroup = fullPreference.find((g) => g.type === key);
    if (!rootGroup) return;

    const entries = dedupeSelected(flattenSelected(selectedItems));

    const selectedQty = {};
    entries.forEach((item) => {
      selectedQty[String(item.preferenceSku)] = item.quantity ?? 1;
    });

    const chains = entries
      .map((item) => getParentPath(item, key, selectedQty))
      .filter((chain) => chain.length > 0);

    const selection = selectedPre(chains);

    result.push({
      title: key,
      selection,
    });
  });

  return result;
};
